import { useMemo } from 'react'
import { useFormatPolePrice } from 'components/common/hooks/useFormatPolePrice'
import { usePricingTypes } from 'components/common/hooks/usePricingTypes'
import { upperFirstOnly } from 'utils/format'

const useVisiblePrices = (station, validFuelGrades, selectedFuelGrade) => {
  const { formatPolePrice, formatPolePriceDate } = useFormatPolePrice()
  const { selectedPricingType } = usePricingTypes()

  return useMemo(
    () =>
      station.polePrices
        .filter((price) => {
          const priceType = price.pricingType
          if (
            (priceType !== 'ALL' &&
              selectedPricingType !== 'ALL' &&
              selectedPricingType !== priceType) ||
            (station.cashCreditPricing && priceType === 'ALL')
          ) return false
          return true
        })
        .map((price) => {
          const fuelGrade = validFuelGrades?.find(
            (fg) => fg.id === price.fuelGradeId
          )
          if (!fuelGrade) return null
          const pricingLabel = price.pricingType === 'ALL'
            ? ''
            : ` (${upperFirstOnly(price.pricingType)})`
          return {
            key: `${price.pricingType}-${price.fuelGradeId}`,
            gradeColor: fuelGrade.color,
            gradeName: fuelGrade.shortTitle,
            dateLabel: `${formatPolePriceDate(price.priceUpdatedAt)}${pricingLabel}`,
            formattedPrice: formatPolePrice(price.price),
            source: price.source,
            isSelected: price.fuelGradeId === selectedFuelGrade,
          }
        })
        .filter(Boolean),
    [selectedPricingType, station.polePrices, station.cashCreditPricing, selectedFuelGrade, validFuelGrades, formatPolePrice, formatPolePriceDate]
  )
}

export { useVisiblePrices }
